module.exports = __webpack_public_path__ + "img/rectangle.10ed1491.svg";